import React from 'react'

interface IcAttachmentProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcAttachment: React.FC<IcAttachmentProps> = ({
  width = '16px',
  height = '16px',
  color = '#666666',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M3.67236 4.8L11.3982 4.82389C13.3691 4.82998 14.9162 6.3646 14.8538 8.25154C14.7914 10.1385 13.143 11.6632 11.1721 11.6571L3.4463 11.6332C2.13235 11.6292 1.10093 10.6061 1.14254 9.34814C1.18416 8.09018 2.28306 7.07369 3.59701 7.07775L11.3269 7.10567C11.9838 7.1077 12.4996 7.61924 12.4787 8.24822C12.4579 8.87721 11.9085 9.38545 11.2515 9.38342L4.11853 9.35734"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcAttachment
